var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.625C3 5.39453 3.98438 4.375 5.25 4.375H18.75C19.9805 4.375 21 5.39453 21 6.625V17.875C21 19.1406 19.9805 20.125 18.75 20.125H5.25C3.98438 20.125 3 19.1406 3 17.875V6.625ZM10.875 18.4375H18.75C19.0312 18.4375 19.3125 18.1914 19.3125 17.875V6.625C19.3125 6.34375 19.0312 6.0625 18.75 6.0625H10.875V18.4375ZM6.09375 8.3125H7.78125C8.23828 8.3125 8.625 7.96094 8.625 7.46875C8.625 7.01172 8.23828 6.625 7.78125 6.625H6.09375C5.60156 6.625 5.25 7.01172 5.25 7.46875C5.25 7.96094 5.60156 8.3125 6.09375 8.3125ZM6.09375 10C5.60156 10 5.25 10.3867 5.25 10.8438C5.25 11.3359 5.60156 11.6875 6.09375 11.6875H7.78125C8.23828 11.6875 8.625 11.3359 8.625 10.8438C8.625 10.3867 8.23828 10 7.78125 10H6.09375ZM6.09375 15.0625H7.78125C8.23828 15.0625 8.625 14.7109 8.625 14.2188C8.625 13.7617 8.23828 13.375 7.78125 13.375H6.09375C5.60156 13.375 5.25 13.7617 5.25 14.2188C5.25 14.7109 5.60156 15.0625 6.09375 15.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarLeft);
export default __webpack_public_path__ + "static/media/SideBarLeft.0df3e1ce9e7f64e2845222a7d2a24971.svg";
export { ForwardRef as ReactComponent };